import React from 'react';
type BrandSymbolProps = {
  size?: number;
  tone?: 'dark' | 'light';
  className?: string;
};
export function BrandSymbol({
  size = 36,
  tone = 'dark',
  className = ''
}: BrandSymbolProps) {
  const gold = tone === 'dark' ? '#C9A96E' : '#A88544';
  const accent = tone === 'dark' ? '#93ABD6' : '#3B5B94';
  return <svg viewBox="0 0 48 48" width={size} height={size} className={className} aria-hidden="true" focusable="false" data-id="element-41" data-mp="25vwgqmjol2qq">
      <path d="M34 14 L24 4 L4 24 L24 44 L34 34" fill="none" stroke={gold} strokeWidth="4.5" strokeLinejoin="miter" strokeLinecap="square" data-id="element-42" data-mp="1rvlopg6mxi3z" />
      <path d="M28 24 H41" stroke={accent} strokeWidth="3" strokeLinecap="round" data-id="element-43" data-mp="1hz0jouum8705" />
      <rect x="19.5" y="19.5" width="9" height="9" transform="rotate(45 24 24)" fill={gold} data-id="element-44" data-mp="1i1d89quvpfm6" />
      <circle cx="43" cy="24" r="3.4" fill={accent} data-id="element-45" data-mp="1n06dkw00i0b9" />
    </svg>;
}